import { Dictionary } from '../../models/Dictionary';
import { Group } from '../../models/entities';
import { MapGroupViewModel } from './MapGroupViewModel';

export const getGroupGuidsOnMap = (groups: Group[], groupDictionary?: Dictionary<MapGroupViewModel>) => {
    return groups?.filter((d) => !!d.customProperties && d.customProperties['latitude'] && d.customProperties['longitude']).map((group) => group.guid) ?? [];
};
